<template>
  <div class="button-frame button-container">
    <img class="imagebtn"
    :src="require(`../assets/slides-icons/deepsleep.svg`)"
    @click="openPopUp" />
    <div v-show="visibility">
      <div class="overlay" @click.self="closePopUp"></div>
      <div class="pop-up">
        <popup-slides :slides="iconSlides" :isPreview="isPreview" />
      </div>
    </div>
  </div>
</template>

<script>
import PopUpSlides from './PopupSlidesComponent.vue'

export default {
  name: 'OverlaySlides',
  props: {
    iconSlides: {
      type: Array,
      require: true,
    },
    isPreview: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'popup-slides': PopUpSlides
  },
  data() {
    return { visibility: false };
  },
  methods: {
    openPopUp() {
      this.visibility = true;
    },
    closePopUp() {
      this.visibility = false;
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '~@eds/vanilla/variables/global.less';
.overlay {
  position: fixed;
  z-index: 10;
  top: 0;
  right: 0;
  height: 100vh;
  width: 100vw;
  background-color: black;
  opacity: 0.5;
}
.pop-up {
  width: 80%;
  position: fixed;
  z-index: 20;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: black;
}
.imagebtn {
  margin-left: 15px;
  margin-right: 15px;
  position: relative;
  cursor: pointer;
  transform: scale(2);
  width: 14px;
  height: 14px;
  top: -5px;
}
.button-frame {
   user-select: none;
}
.item-image {
  width: 100%;
}
.button-container {
  display: inline-block;
}
</style>